import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { catalogCreateConstructionTypeMutation } from '../catalogConstructionTypesQueries';

interface IUseCreateConstructionType {
    onSuccessHandler: () => void;
}

export const useCreateConstructionType = ({ onSuccessHandler }: IUseCreateConstructionType) => {
    const [createData, createStatus, createError, createRequest] = useRequest({
        requestId: 'createConstructionType',
        query: catalogCreateConstructionTypeMutation,
        withEffect: false,
        dependenciesUpdater: ({ payload }) => {
            if (payload?.catalogCreateConstructionType?.result) {
                onSuccessHandler();
            }
        },
    });
    const [resetCreatingData] = useResetStoreData({ requestId: 'createConstructionType' });

    return {
        createConstructionTypeData: createData?.catalogCreateConstructionType,
        createConstructionTypeStatus: createStatus,
        createConstructionTypeError: createError,
        createConstructionTypeRequest: createRequest,
        resetCreatingData,
        isCreatingInProgress: createStatus === RequestStatus.FETCHING,
    };
};
